import Selectr from "mobius1-selectr"
import Pikaday from "pikaday"

export default function init() {
  document.querySelectorAll("select").forEach(element => {
    const selectr = new Selectr(element, {
      searchable: !!element.attributes.searchable,
      placeholder: element.attributes.placeholder ? element.attributes.placeholder.value : null,
    })
    selectr.on("selectr.init", function() {
      // bubble event to DOM element so it can be listened to elsewhere
      element.dispatchEvent(new Event("selectr.init"))

      // Make selected div act like button
      selectr.selected.setAttribute("role", "button")
      selectr.selected.setAttribute("aria-expanded", "false")

      // Remove aria-expanded from tree
      const tree = selectr.container.querySelector(".selectr-options")
      if (tree) {
        tree.removeAttribute("aria-expanded")
      }

      // Update aria-expanded on open/close
      selectr.on("selectr.open", () => {
        selectr.selected.setAttribute("aria-expanded", "true")
      })
      selectr.on("selectr.close", () => {
        selectr.selected.setAttribute("aria-expanded", "false")
      })

      // prevent scroll when opening dropdown
      selectr.selected.addEventListener("keydown", e => {
        // spacebar
        if (e.keyCode == 32) {
          e.preventDefault()
        }
      })

      selectr.items.forEach(option => {
        // allow tabbing
        option.setAttribute("tabindex", 0)

        // close dropdown when tabbing out of it
        option.addEventListener("blur", () => {
          setTimeout(() => {
            const activeElement = document.activeElement
            if (!selectr.container.contains(activeElement)) {
              selectr.close()
              activeElement.focus()
            }
          }, 1)
        })

        // add arrow navigation
        option.addEventListener("keydown", e => {
          if (e.keyCode == 13) {
            e.preventDefault()
            e.stopPropagation()
          }
          if (e.keyCode == 32) {
            // spacebar
            e.preventDefault()
            option.click()
          }

          // arrow down
          if (e.keyCode == 40) {
            const nextOption = option.nextElementSibling
              ? option.nextElementSibling
              : option.parentElement.firstElementChild
            nextOption.focus()
          }

          // arrow up
          if (e.keyCode == 38) {
            const nextOption = option.previousElementSibling
              ? option.previousElementSibling
              : option.parentElement.lastElementChild
            nextOption.focus()
          }
        })
      })
    })
  })

  document.querySelectorAll("form").forEach(form => {
    const recaptcha = form.querySelector(".g-recaptcha")
    const uploadFields = document.querySelectorAll('input[type="file"]')

    if (recaptcha) {
      recaptcha.setAttribute("data-callback", "recaptchaCallback")
      const submitButton = form.querySelectorAll("input[type=submit]")
      const errorDiv = document.createElement("div")

      submitButton.forEach(button => {
        button.setAttribute("disabled", "disabled")
      })
      errorDiv.innerText = "Please complete the reCAPTCHA to Submit Form"
      errorDiv.style.color = "red"
      errorDiv.style.paddingTop = "5px"
      recaptcha.parentNode.insertBefore(errorDiv, recaptcha.nextSibling)
      window.recaptchaCallback = function() {
        submitButton.forEach(button => {
          button.removeAttribute("disabled")
        })
        errorDiv.style.display = "none"
      }
    }

    uploadFields.forEach(function(uploadField) {
      uploadField.addEventListener("change", function() {
        const messageField = document.getElementById(uploadField.name + "_message")

        if (messageField) {
          messageField.remove()
        }
      })
    })
  })

  // Prefer to use a text input with class 'date-picker',
  // so can set input value to a custom date format "dd/mm/yyyy"
  document.querySelectorAll("input.date-picker").forEach(element => {
    if (!element.pickaday) {
      createDatePicker(element)
    }
  })

  // Also support userforms that use a date input,
  // these set the value using standard html format "yyyy-mm-dd"
  document.querySelectorAll("input[type='date']").forEach(element => {
    if (!element.pickaday) {
      element.setAttribute("type", "text")
      element.classList.add("date-picker")
      createDatePicker(element)
    }
  })

  function createDatePicker(element) {
    element.placeholder = "dd/mm/yyyy"

    let pickaday = new Pikaday({
      field: element,
      toString(date) {
        const day = date
          .getDate()
          .toString()
          .padStart(2, "0")
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear()
        return `${day}/${month}/${year}`
      },
      parse(dateString) {
        // dateString is the result of `toString` method
        const parts = dateString.split("/")
        const day = parseInt(parts[0], 10)
        const month = parseInt(parts[1], 10) - 1
        const year = parseInt(parts[2], 10)
        return new Date(year, month, day)
      },
      showDaysInNextAndPreviousMonths: true,
      i18n: {
        previousMonth: "Previous Month",
        nextMonth: "Next Month",
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"],
      },
    })

    element.pickaday = pickaday

    // <i class="material-icons">date_range</i>
    const icon = document.createElement("i")
    icon.innerText = "date_range"
    icon.classList.add("material-icons")
    // insertAfter
    element.parentNode.insertBefore(icon, element.nextSibling)
  }
}
